export default __webpack_public_path__ + "static/media/jajakallah2.d4dfdecc.png";